<template>
  <div>
    <v-data-table
      dense
      multi-sort
      :headers="headers"
      :items="items"
      :options.sync="options"
      :server-items-length="totalItems"
      :loading="loading"
      class="elevation-1">
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-btn rounded small @click="refresh" color="accent" title="Reîncărcare date tabel">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
          <v-divider vertical class="mx-4" inset></v-divider>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" label="Căutare" class="mx-4" clearable hide-details></v-text-field>
          <v-spacer></v-spacer>
          <v-divider vertical class="mx-4" inset></v-divider>
          <v-btn small color="primary" rounded @click="openItemDialog" title="Adăugare întrebare">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:item._id="{ item }">
        <span style="display: inline-block; width: 50px" class="text-truncate" :title="item._id">
          {{ item._id }}
        </span>
      </template>
      <template v-slot:item.content="{ item }">
        <div v-html="item.content"></div>
      </template>
      <template v-slot:item.actions="{ item }">
        <div style="white-space: nowrap">
          <v-icon
            small
            class="mr-2"
            @click="editItem(item)"
            color="accent"
            title="editeaza cont">
            mdi-pencil
          </v-icon>
          <v-icon
            small
            class="mr-2"
            @click="deleteItem(item)"
            color="error"
            title="sterge cont">
            mdi-delete
          </v-icon>
        </div>
      </template>
      <template v-slot:item.createdAt="{ item }">
        {{ (new Date(item.createdAt)).toLocaleString('ro-RO') }}
      </template>
      <template v-slot:item.updatedAt="{ item }">
        {{ (new Date(item.updatedAt)).toLocaleString('ro-RO') }}
      </template>
    </v-data-table>

    <v-dialog
      persistent
      scrollable
      v-model="itemForm"
      width="500">
      <v-card max-height="75vh">
        <v-card-title>
          <span>{{ itemAction === 'add' ? 'Adaugare' : 'Modificare' }} FAQ</span>
          <v-spacer></v-spacer>
          <v-btn icon small>
            <v-icon small color="error" @click="closeItemDialog">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form v-model="validForm" ref="form">
            <v-text-field
              v-model="item.title"
              label="Titlu întrebare"
              hint="Text ce apare înainte ca întrebarea să fie deschisă de către utilizator."
              required
              :rules="[rules.required]">
            </v-text-field>
            <v-textarea
              v-model="item.content"
              label="Conținut"
              hint="Răspuns la întrebarea din titlu. Poate conține cod HTML."
              required
              :rules="[rules.required]">
            </v-textarea>
            <v-text-field
              v-model.number="item.index"
              type="number"
              min="1"
              step="1"
              label="Index"
              hint="Întrebările vor fi ordonate după acest câmp."
              required
              :rules="[rules.required]">
            </v-text-field>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-alert type="error" v-if="message" dismissible @input="alertChanged">{{ message }}</v-alert>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" outlined @click="closeItemDialog">Închide</v-btn>
          <v-btn color="primary" @click="saveItem">Salvează Întrebare</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      persistent
      scrollable
      v-model="deleteItemDialog"
      width="500">
      <v-card max-height="75vh">
        <v-card-title>Confirmati ștergerea?</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" outlined @click="cancelDelete">Anulează ștergerea</v-btn>
          <v-btn color="primary" @click="confirmDelete">Șterge Întrebare</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import _debounce from 'lodash.debounce'

export default {
  name: 'FaqComponent',

  data: () => ({
    headers: [
      {
        text: 'id',
        value: '_id',
        align: 'start',
        sortable: false,
        filterable: false
      },
      {
        text: 'titlu',
        value: 'title',
        align: 'left',
        sortable: true,
        filterable: true
      },
      {
        text: 'conținut',
        value: 'content',
        align: 'left',
        sortable: true,
        filterable: true
      },
      {
        text: 'index',
        value: 'index',
        align: 'right',
        sortable: false,
        filterable: false
      },
      {
        text: 'creat',
        value: 'createdAt',
        align: 'start',
        sortable: true,
        filterable: true
      },
      {
        text: 'modificat',
        value: 'updatedAt',
        align: 'start',
        sortable: true,
        filterable: true
      },
      {
        text: 'acțiuni',
        value: 'actions',
        sortable: false,
        filterable: false
      }
    ],
    item: {
      _id: null,
      title: null,
      content: null,
      index: null
    },
    itemForm: false,
    itemAction: 'add',
    validForm: true,
    deleteItemDialog: false,
    deleteItemID: null,
    rules: {
      required: val => !!val || 'Câmpul nu poate fi gol!'
    },
    message: null
  }),

  computed: {
    items () {
      return this.$store.getters.faqItems
    },
    options: {
      get () {
        return this.$store.getters.faqOptions
      },
      set (value) {
        this.$store.dispatch('setFaqOptions', value)
      }
    },
    totalItems () {
      return this.$store.getters.faqTotal
    },
    loading () {
      return this.$store.getters.faqLoading
    },
    search: {
      get () {
        return this.$store.getters.faqSearch
      },
      set: _debounce(function (value) {
        this.$store.dispatch('setFaqSearch', value)
      }, 500)
    },
    user () {
      return this.$store.getters.user
    }
  },

  methods: {
    refresh () {
      this.$store.dispatch('fetchFaq')
    },

    resetForm () {
      this.$refs.form.resetValidation()
      this.item = Object.assign(this.item, {}, JSON.parse(JSON.stringify(defaultItem)))
      this.itemAction = 'add'
    },
    closeItemDialog () {
      this.itemForm = false
      this.item = Object.assign(this.item, {}, JSON.parse(JSON.stringify(defaultItem)))
      this.resetForm()
      this.message = null
    },
    openItemDialog () {
      this.itemForm = true
      this.itemAction = 'add'
    },
    async saveItem () {
      const valid = this.$refs.form.validate()
      if (valid) {
        const payload = Object.assign({}, this.item)
        const result = await this.$store.dispatch('saveFaq', payload)
        if (result === true) {
          this.closeItemDialog()
        } else {
          this.message = 'Ne pare rău. A apărut o eroare la procesarea cererii...'
        }
      }
    },
    editItem (item) {
      this.item._id = item._id

      this.item.title = item.title
      this.item.content = item.content
      this.item.index = item.index

      this.itemAction = 'edit'
      this.itemForm = true
    },
    deleteItem (item) {
      this.deleteItemID = item._id
      this.deleteItemDialog = true
    },
    confirmDelete () {
      const payload = this.deleteItemID
      this.$store.dispatch('deleteFaq', payload)
      this.deleteItemID = null
      this.deleteItemDialog = false
    },
    cancelDelete () {
      this.deleteItemID = null
      this.deleteItemDialog = false
    },
    alertChanged ($event) {
      if (!$event) this.message = null
    }
  }
}

const defaultItem = {
  _id: null,
  title: null,
  content: null,
  index: null
}
</script>
